import React, { Component } from "react"
import {
  Layout,
  Button,
  Icon,
  Carousel,
  Anchor,
  Tag,
  Menu,
  Dropdown,
} from "antd"
import { withTranslation } from "react-i18next"
import protocolcheck from "../../../utils/protocolcheck"
const { Content } = Layout
class ScpController extends Component {
  constructor(props) {
    super(props)
    this.state = {}
  }
  componentDidMount() {
    const params = new URLSearchParams(this.props.location.search)
    let op = params.get("op")
    let opid = params.get("opid")
    let kbid = params.get("kbid")
    let datasource = params.get("datasource")
    let serviceregions = params.get("serviceregions")
    let paramStr = ""
    if (!op) return
    if (op === "kbshare") {
      paramStr =
        "-s WEB -m Search true -showdetail Y -datasource " +
        datasource +
        " -op " +
        op +
        " -opid " +
        opid +
        " -kbid " +
        kbid
      paramStr = new Buffer(paramStr).toString("base64")
    }
    //document.write('<iframe id="trigger_protocol_ifrm" style="display:none" src="Escloud:'+paramStr+'"></iframe>');
    console.info("Escloud:" + paramStr)
    if(!sessionStorage.getItem("Escloud")){
      setTimeout(() => {
        window.location.reload();
        sessionStorage.setItem("Escloud",1);
      },1500)
      return false;
    }
    
    protocolcheck(
      "Escloud:" + paramStr,
      () => {
        if (serviceregions === "CN") {
          alert("请先安裝鼎捷云管家或升级至最新版本！") //请先安裝鼎捷云管家或升级至最新版本！
          // location.href = 'http://es-ygj.digiwincloud.com.cn'
          this.props.history.push({ pathname: "/productDownload" })
        } else if (serviceregions === "TW") {
          alert("請先安裝鼎新雲管家或升級至最新版本！")
          //   alert(translate.instant('scpcontroller.scpinstallmsg')) //请先安裝鼎捷云管家或升级至最新版本！
          this.props.history.push({ pathname: "/productDownload" })
        } else {
          alert(
            "Please Install Digiwin Escloud Managerment First Or Update To The Latest Version!"
          ) //请先安裝鼎捷云管家或升级至最新版本！
          // location.href = 'http://es-ygj.digiwincloud.com'
          this.props.history.push({ pathname: "/productDownload" })
        }
      },
      function () {},
      function () {}
    )
  }
  render() {
    const { t } = this.props
    return <Content className="q-content-wrapper"></Content>
  }
}
export default withTranslation()(ScpController)
